'use client';
import { Box, Breadcrumb, Image } from '@/components';
import { useTranslation } from '@/hooks';
import { routes } from '@/statics';

const Banner: React.FC<{
  title: string;
  bannerDesktop: string;
  bannerMobile: string;
}> = ({ title, bannerDesktop, bannerMobile }) => {
  const { t } = useTranslation('pages');
  return (
    <>
      <Breadcrumb
        mb="35px"
        list={[
          { title: t('home.home'), href: routes.home.url },
          {
            title: t('blogs.blog'),
            href: routes.blogs.url,
          },
          {
            title: title,
            href: routes.blogs.url,
          },
        ]}
      />
      <Box
        display={{ base: 'none', md: 'block' }}
        aspectRatio={1350 / 373}
        width="100%"
        position="relative"
        sx={{
          mt: { base: '55px', md: '81px' },
          '& img': { objectFit: 'cover', width: '100%', borderRadius: 'lg' },
        }}
      >
        <Image src={bannerDesktop} alt={title} fill />
      </Box>
      <Box
        display={{ base: 'block', md: 'none' }}
        aspectRatio={257 / 247}
        width="100%"
        position="relative"
        sx={{
          mt: { base: '55px', md: '81px' },
          '& img': { objectFit: 'cover', width: '100%', borderRadius: 'lg' },
        }}
      >
        <Image src={bannerMobile} alt={title} fill />
      </Box>
    </>
  );
};
export default Banner;
